/**** mgt.TicketType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'TicketType',
  title: 'Типы билетов',
  apiType: apiTypes.DEFAULT,
  connections: {
    ticketview: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'TicketView',
      index: 'ticket_kind_id',
      fields: ['ticket_kind_name'],
      format: (elem: any) => `${elem['ticket_kind_name']}`,
      autocomplete: true,
    }
  },
  elemsOnPage: 100,
  fields: [
    {
      name: 'ticket_type_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'ticket_type_code',
      title: 'Код',
      type: 'text',
      required: true
    },
    {
      name: 'ticket_type_name',
      title: 'Наименование',
      type: 'text',
      required: true
    },
    {
      name: 'ticket_kind_id',
      title: 'Вид билета',
      type: 'number',
      required: false,
      connection: 'ticketview'
    }
  ],
  newTemplate: {
    ticket_type_id: null,
    ticket_type_code: '',
    ticket_type_name: '',
    ticket_kind_id:null
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'ticket_type_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'ticket_type_id',
        field: 'ticket_type_id',
      },{
        title: 'ticket_type_code',
        field: 'ticket_type_code',
      },{
        title: 'ticket_type_name',
        field: 'ticket_type_name',
      },{
        title: 'ticket_kind_id',
        field: 'ticket_kind_id',
      }
    ],
    example: `1;Код;Название;1`,
  },
  export: {
    fields: [
      {
        name: 'ticket_type_code',
        title: 'Код',
      },
      {
        name: 'ticket_kind_name',
        title: 'Наименование',
      },
      {
        name: 'ticket_kind_id',
        title: 'Вид билета',
        connectionField: 'ticket_kind_id'
      }
    ]
  }
};

export default config;